<div class="modal-header">
  <h4 class="modal-title">
    Докладване на потребител
  </h4>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="closeModal()">
  </button>
</div>
<div class="modal-body" nzForceRepaint>
  <form [formGroup]="form">
    <div class="alert alert-warning">
      <p>
        Опишете подробно ситуацията и причината за доклада. Нашият екип ще разгледа случая и ще предприеме необходимите
        действия.
      </p>
      <p class="mb-0">
        Ако докладът бъде потвърден, <strong>{{ username }}</strong> може да бъде санкциониран или да му бъдат наложени
        ограничения за достъп.
      </p>
    </div>
    <div class="form-floating">
        <textarea
          class="form-control"
          placeholder="Leave a comment here"
          id="floatingTextarea2"
          rows="6"
          formControlName="description"
          style="height: 100px"
          [class.is-valid]="description?.touched && description?.valid"
          [class.is-invalid]="description?.touched && description?.invalid">
        </textarea>
      <p class="invalid-feedback m-0">Задължително поле!</p>
      <label for="floatingTextarea2">Описание на проблема</label>
    </div>
  </form>
</div>
<div class="modal-footer d-block text-end">
  <button
    type="button"
    class="me-2 btn btn-outline-secondary"
    (click)="closeModal()">
    <span>Затвори</span>
  </button>
  <button
    type="button"
    [disabled]="loading"
    class="btn btn-nz-primary"
    (click)="onSubmit()">
    @if (loading) {
      <span class="me-2 spinner-border spinner-border-sm"></span>
    }
    <span>Изпрати</span>
  </button>
</div>
